import React, { Component } from "react";
import "./SchedulePage.css";
import { withRouter } from "react-router-dom";
import LoginModal from "../modal/loginModal";

/* Helper Functions */
function calculateDaysRemaining(expiryDate) {
  const expiry = new Date(expiryDate);
  const today = new Date();
  const diffTime = expiry - today;
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

function calculateProgressPercentage(startDate, endDate) {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const today = new Date();

  const totalDuration = end - start;
  const elapsedDuration = today - start;

  return Math.min(
    Math.max(Math.round((elapsedDuration / totalDuration) * 100), 0),
    100,
  );
}

function getNextSessionTime(scheduleTime) {
  const now = new Date();
  const timeParts = scheduleTime.split(":");
  const scheduledHour = parseInt(timeParts[0]);
  const scheduledMinute = parseInt(timeParts[1]);

  const nextSession = new Date();
  nextSession.setHours(scheduledHour, scheduledMinute, 0, 0);

  if (nextSession < now) {
    nextSession.setDate(nextSession.getDate() + 1);
  }

  const options = {
    weekday: "long",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  return nextSession.toLocaleTimeString("en-US", options);
}

function copyToClipboard(text) {
  navigator.clipboard.writeText(text).then(() => {
    alert("Schedule ID copied to clipboard!");
  });
}

class SchedulePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      schedules: [],
      msisdn: null,
      scheduleInfo: null,
      loading: true,
      error: null,
      popup: { isOpen: false, type: "", data: null },
      selectedSchedule: null, // নতুন state: নির্বাচিত schedule
      showDropdown: false, // নতুন state: dropdown দেখানো/না দেখানো
      showLoginModal: false,
    };

    this.API_URL = "https://api.iqra-live.com/api/v1/sehri-schedule/";

    // Bind methods
    this.fetchScheduleData = this.fetchScheduleData.bind(this);
    this.handleScheduleClick = this.handleScheduleClick.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.handleBuyClick = this.handleBuyClick.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.formatTime = this.formatTime.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
    this.subSchedule = this.subSchedule.bind(this);
    this.handleScheduleSelect = this.handleScheduleSelect.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  componentDidMount() {
    console.log("SchedulePage mounted");
    console.log("Full URL:", window.location.href);
    console.log("Search params:", window.location.search);

    // সরাসরি window.location থেকে msisdn পড়ুন
    const urlParams = new URLSearchParams(window.location.search);
    const queryMsisdn = urlParams.get("msisdn");

    console.log("Extracted MSISDN from URL:", queryMsisdn);

    if (!queryMsisdn) {
      // যদি URL-এ msisdn না থাকে, তবে localStorage থেকে চেক করুন
      const storedMsisdn = localStorage.getItem("msisdn");
      if (storedMsisdn) {
        console.log("Using stored MSISDN:", storedMsisdn);
        this.setState({ msisdn: JSON.parse(storedMsisdn) });
      } else {
        console.log("No MSISDN found anywhere");
        this.setState({
          showLoginModal: true,
          loading: false,
        });
      }
      return;
    }

    // URL থেকে পাওয়া msisdn সেট করুন
    this.setState({ msisdn: queryMsisdn });

    // localStorage-এ সেভ করুন ভবিষ্যতের জন্য
    localStorage.setItem("msisdn", JSON.stringify(queryMsisdn));
    console.log("MSISDN saved to localStorage:", queryMsisdn);
  }

  componentDidUpdate(prevProps, prevState) {
    // msisdn পরিবর্তন হলে data fetch করুন
    if (prevState.msisdn !== this.state.msisdn && this.state.msisdn) {
      console.log("MSISDN changed, fetching data:", this.state.msisdn);
      this.fetchScheduleData();
    }

    // schedules পাওয়ার পর প্রথম available schedule নির্বাচন করুন
    if (
      prevState.schedules !== this.state.schedules &&
      this.state.schedules.length > 0
    ) {
      this.selectDefaultSchedule();
    }

    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  /* ==============================
     LOGIN HANDLING
  ============================== */

  handleLoginSuccess = (msisdn) => {
    localStorage.setItem("msisdn", JSON.stringify(msisdn));

    this.setState({
      msisdn,
      showLoginModal: false,
      loading: true,
    });
  };

  // নতুন মেথড যোগ করুন
  handleClickOutside = (event) => {
    const { showDropdown } = this.state;

    if (showDropdown && !event.target.closest(".custom-dropdown")) {
      this.setState({ showDropdown: false });
    }
  };

  // constructor-এ bind করুন

  // প্রথম available schedule নির্বাচন করুন
  selectDefaultSchedule() {
    const { schedules } = this.state;

    // প্রথম available schedule খুঁজুন
    const availableSchedule = schedules.find(
      (schedule) => schedule.available_schedule > 0,
    );

    if (availableSchedule) {
      this.setState({ selectedSchedule: availableSchedule });
    } else if (schedules.length > 0) {
      // যদি কোন available schedule না থাকে, তবে প্রথমটিই নির্বাচন করুন
      this.setState({ selectedSchedule: schedules[0] });
    }
  }

  // Function to fetch schedule data
  async fetchScheduleData() {
    const { msisdn } = this.state;
    console.log("Starting fetchScheduleData with MSISDN:", msisdn);

    if (!msisdn) {
      this.setState({
        error: "MSISDN is required to fetch schedule data.",
        loading: false,
      });
      return;
    }

    try {
      this.setState({ loading: true, error: null });

      // API URL তৈরি করুন
      const apiUrl = `${this.API_URL}${msisdn}`;
      console.log("API URL:", apiUrl);

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          accessinfo: {
            access_token: "K165S6V6q4C6G7H0y9C4f5W7t5YeC6",
            referenceCode: "20260203223311",
          },
        }),
      });

      console.log("API Response status:", response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error("API Error response:", errorText);
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("API Response data:", data);

      // Check if data has expected structure
      if (!data) {
        throw new Error("No data received from API");
      }

      // Set the state with API response
      this.setState({
        schedules: data.schedule_list || [],
        scheduleInfo: data.schedule_info || null,
        loading: false,
      });
    } catch (err) {
      console.error("Error in fetchScheduleData:", err);
      this.setState({
        error: `Failed to load schedule data: ${err.message}`,
        loading: false,
      });
    }
  }

  // Handle schedule selection from dropdown
  handleScheduleSelect(schedule) {
    this.setState({
      selectedSchedule: schedule,
      showDropdown: false,
    });
  }

  // Toggle dropdown visibility
  toggleDropdown() {
    this.setState((prevState) => ({
      showDropdown: !prevState.showDropdown,
    }));
  }

  // Handle refresh button click
  handleRefresh() {
    const { msisdn } = this.state;
    if (msisdn) {
      this.fetchScheduleData();
    } else {
      // URL থেকে আবার msisdn পড়ার চেষ্টা করুন
      const urlParams = new URLSearchParams(window.location.search);
      const queryMsisdn = urlParams.get("msisdn");
      if (queryMsisdn) {
        this.setState({ msisdn: queryMsisdn });
      } else {
        this.setState({
          error:
            "MSISDN not found. Please refresh the page with msisdn parameter.",
          loading: false,
        });
      }
    }
  }

  // Handle schedule item click
  handleScheduleClick(schedule) {
    const { scheduleInfo } = this.state;

    if (scheduleInfo != null) {
      alert(
        "You already have an active subscription. Please cancel your current subscription first.",
      );
      return;
    }

    if (schedule.available_schedule === 0) {
      return; // Do nothing for disabled schedules
    }

    this.setState({
      popup: {
        isOpen: true,
        type: "subscribe",
        data: schedule,
      },
    });
  }

  subSchedule(schedule) {
    const { msisdn } = this.state;
    console.log("Redirecting to subscription API:", schedule.sub_api);

    // URL-এ msisdn যোগ করুন যাতে ফিরে আসার সময় থাকে
    const redirectUrl = `${schedule.sub_api}?schedule_id=${schedule.schedule_id}&schedule_time=${schedule.schedule_time}&msisdn=${msisdn}`;
    console.log("Redirect URL:", redirectUrl);
    window.location.href = redirectUrl;
  }

  // Handle cancel button click
  handleCancelClick() {
    const { scheduleInfo } = this.state;
    console.log("Current schedule info:", scheduleInfo);

    if (!scheduleInfo) return;

    this.setState({
      popup: {
        isOpen: true,
        type: "cancel",
        data: scheduleInfo,
      },
    });
  }

  // Handle buy button click with proper event handling
  handleBuyClick(schedule, e) {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
      e.nativeEvent.stopImmediatePropagation();
    }

    console.log("Buy button clicked!");
    console.log("Schedule data:", schedule);
    console.log("Current scheduleInfo:", this.state.scheduleInfo);

    const { scheduleInfo } = this.state;

    if (scheduleInfo != null) {
      alert(
        "You already have an active subscription. Please cancel your current subscription first.",
      );
      return;
    }

    if (schedule.available_schedule === 0) {
      alert("This time slot is fully booked.");
      return;
    }

    // Call the subscription function
    this.subSchedule(schedule);
  }

  // Handle popup confirmation
  async handleConfirm() {
    const { popup, msisdn } = this.state;

    if (popup.type === "subscribe") {
      // Redirect to sub_api with msisdn parameter
      const redirectUrl = `${popup.data.sub_api}?msisdn=${msisdn}`;
      console.log("Redirecting to:", redirectUrl);
      window.location.href = redirectUrl;
    } else if (popup.type === "cancel") {
      try {
        // Make API call to cancel
        console.log(
          "Making API call to cancel subscription...",
          popup.data.sub_api,
        );

        const response = await fetch(popup.data.sub_api, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            accessinfo: {
              access_token: "K165S6V6q4C6G7H0y9C4f5W7t5YeC6",
              referenceCode: "20260203223311",
            },
          }),
        });

        if (response.ok) {
          // Refresh the data after successful cancellation
          this.fetchScheduleData();
          alert("Subscription cancelled successfully!");
        } else {
          throw new Error("Failed to cancel subscription");
        }
      } catch (err) {
        this.setState({ error: err.message });
        console.error("Error cancelling subscription:", err);
      }
    }

    // Close popup
    this.setState({ popup: { isOpen: false, type: "", data: null } });
  }

  // Handle popup close
  handlePopupClose() {
    this.setState({ popup: { isOpen: false, type: "", data: null } });
  }

  // Format time if needed
  formatTime(time) {
    // Add any time formatting logic here
    return time;
  }

  // Placeholder functions for future features
  handleReschedule(schedule) {
    alert("Reschedule feature coming soon!");
  }

  handlePause(schedule) {
    alert("Pause feature coming soon!");
  }

  render() {
    const {
      schedules,
      msisdn,
      scheduleInfo,
      loading,
      error,
      popup,
      selectedSchedule,
      showDropdown,
      showLoginModal,
    } = this.state;

    this.handleClickOutside = this.handleClickOutside.bind(this);

    // Render loading state
    if (loading) {
      return (
        <div className="schedule-container loading">
          <div className="loader"></div>
          <p>Loading schedules...</p>
          <button
            onClick={this.handleRefresh}
            className="retry-btn"
            style={{ marginTop: "20px" }}
          >
            Refresh
          </button>
        </div>
      );
    }

    // Render error state
    if (error) {
      return (
        <div className="schedule-container error">
          <h2>Error Loading Schedule</h2>
          <p>{error}</p>
          <div className="debug-info">
            <p>Current URL: {window.location.href}</p>
            <p>
              MSISDN from URL:{" "}
              {new URLSearchParams(window.location.search).get("msisdn")}
            </p>
            <p>MSISDN in state: {msisdn}</p>
          </div>
          <button onClick={this.handleRefresh} className="retry-btn">
            Retry
          </button>
          <button
            onClick={() =>
              (window.location.href = `/sehri-notification/?msisdn=${msisdn || "YOUR_MSISDN"}`)
            }
            className="retry-btn"
            style={{ marginLeft: "10px", backgroundColor: "#4CAF50" }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    // Check if selected schedule is available
    const isSelectedScheduleAvailable =
      selectedSchedule && selectedSchedule.available_schedule > 0;
    const isSelectedScheduleCurrent =
      scheduleInfo &&
      selectedSchedule &&
      scheduleInfo.schedule_id.trim() === selectedSchedule.schedule_id.trim();

    return (
      <div className="schedule-container">
        {/* Header */}
        <header className="schedule-header">
          <h1>Sehri Wakeup Call Alert</h1>
        </header>

        <LoginModal
          forceOpen={showLoginModal}
          onLoginSuccess={this.handleLoginSuccess}
          msisdn={msisdn}
        />

        {/* Current Subscription Info */}
        {scheduleInfo && (
          <div className="current-subscription-container">
            {/* Header with decorative element */}
            <div className="subscription-header-gradient">
              <div className="header-content">
                <div className="header-title-group">
                  <h2 className="subscription-title">
                    <svg
                      className="title-icon"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                    Current Subscription
                  </h2>
                </div>
              </div>
            </div>

            {/* Subscription details card */}
            <div className="subscription-card">
              {/* Time slot highlight */}
              <div className="time-highlight">
                <div className="clock-display-large">
                  <div className="clock-icon-large">
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="9"
                        stroke="#3B82F6"
                        strokeWidth="2"
                      />
                      <path
                        d="M12 7V12L15 15"
                        stroke="#3B82F6"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <div className="time-details">
                    <span className="time-label">Your Scheduled Time</span>
                    <h3 className="time-value">
                      {this.formatTime(scheduleInfo.schedule_time)}
                    </h3>
                    <span className="time-timezone">Local Time</span>
                  </div>
                </div>
              </div>

              {/* Details grid */}
              <div className="details-grid">
                <div className="detail-card">
                  <div className="detail-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 7V3M16 7V3M7 11H17M5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21Z"
                        stroke="#6B7280"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <div className="detail-content">
                    <span className="detail-label">Expiry Date</span>
                    <span className="detail-value">
                      {new Date(scheduleInfo.expiry_date).toLocaleDateString(
                        "en-US",
                        {
                          weekday: "long",
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        },
                      )}
                    </span>
                  </div>
                </div>

                <div className="detail-card">
                  <div className="detail-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 8V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                        stroke="#6B7280"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <div className="detail-content">
                    <span className="detail-label">Next Session</span>
                    <span className="detail-value">
                      {getNextSessionTime(scheduleInfo.schedule_time)}
                    </span>
                  </div>
                </div>
              </div>

              {/* Action buttons */}
              <div className="action-section">
                <div className="cancel-section">
                  <div className="cancel-warning">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 9V12M12 15H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                        stroke="#EF4444"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                    <span>
                      Once cancelled, you'll lose access to this time slot
                    </span>
                  </div>
                  <button
                    onClick={this.handleCancelClick}
                    className="cancel-btn"
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 6L6 18M6 6L18 18"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Available Schedules - Dropdown Version */}
        {!scheduleInfo && (
          <div className="schedule-selection-container">
            <div className="dropdown-container">
              <div className="dropdown-label">
                Select Your Wakeup Call Time Slot:
              </div>
              <select
                className="time-select"
                value={selectedSchedule ? selectedSchedule.schedule_id : ""}
                onChange={(e) => {
                  const selectedId = e.target.value;
                  const selected = schedules.find(
                    (schedule) => schedule.schedule_id === selectedId,
                  );
                  if (selected) {
                    this.handleScheduleSelect(selected);
                  }
                }}
              >
                <option value="" disabled>
                  Select a time slot
                </option>
                {schedules.map((schedule) => {
                  const isAvailable = schedule.available_schedule > 0;
                  const isCurrent =
                    scheduleInfo &&
                    scheduleInfo.schedule_id.trim() ===
                      schedule.schedule_id.trim();

                  return (
                    <option
                      key={schedule.schedule_id}
                      value={schedule.schedule_id}
                      disabled={!isAvailable}
                      className={`
              ${!isAvailable ? "disabled-option" : ""} 
              ${isCurrent ? "current-option" : ""}
            `}
                    >
                      {this.formatTime(schedule.schedule_time)} -AM
                      {!isAvailable ? " (Fully Booked)" : ` `}
                      {isCurrent ? " - Currently Subscribed" : ""}
                    </option>
                  );
                })}
              </select>
            </div>

            {/* Selected Schedule Details */}
            {selectedSchedule && (
              <div className="selected-schedule-details">
                <div className="schedule-details-card">
                  <div className="details-card-header">
                    <div className="selected-time-display">
                      <h3 className="selected-time-large">
                        <span>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="details-clock-icon"
                          >
                            <circle
                              cx="12"
                              cy="12"
                              r="9"
                              stroke="#34d399"
                              strokeWidth="2"
                            />
                            <path
                              d="M12 7V12L15 15"
                              stroke="#34d399"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </svg>
                        </span>
                        <span>
                          {" "}
                          {this.formatTime(selectedSchedule.schedule_time)}{" "}
                          AM{" "}
                        </span>
                      </h3>
                      <h6 className="text-xs">BDT 7 + ( VAT+SD+SC )</h6>

                      {isSelectedScheduleCurrent && (
                        <div className="current-badge-large">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="12" cy="12" r="10" fill="#10B981" />
                            <path
                              d="M9 12L11 14L15 10"
                              stroke="white"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </svg>
                          <span>Currently Subscribed</span>
                        </div>
                      )}
                    </div>

                    <div className="availability-display">
                      <div className="availability-badge">
                        {!isSelectedScheduleAvailable ? (
                          <span className="badge booked">
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                            Fully Booked
                          </span>
                        ) : (
                          <>
                            <span className="badge available ">
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5 13L9 17L19 7"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                />
                              </svg>
                              <span className="badge-text">
                                You will get a wakeup call at this time slot
                              </span>
                            </span>
                            <span className="badge available">
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5 13L9 17L19 7"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                />
                              </svg>
                              <span className="badge-text">For 7 days</span>
                            </span>
                            <span className="badge available">
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5 13L9 17L19 7"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                />
                              </svg>
                              <span className="badge-text">
                                {selectedSchedule.available_schedule} slots
                                available
                              </span>
                            </span>
                          </>
                        )}
                      </div>

                      <div className="spots-progress">
                        <div className="progress-bar">
                          <div
                            className={`progress-fill ${!isSelectedScheduleAvailable ? "booked" : "available"}`}
                            style={{
                              width: `${!isSelectedScheduleAvailable ? 100 : (selectedSchedule.available_schedule / (selectedSchedule.schedule_limit || 10)) * 100}%`,
                            }}
                          />
                        </div>
                        <div className="progress-text">
                          {selectedSchedule.available_schedule} /{" "}
                          {selectedSchedule.schedule_limit || 10} slots
                          remaining
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="details-card-footer">
                    <button
                      onClick={() => this.handleBuyClick(selectedSchedule)}
                      className={`buy-button ${!isSelectedScheduleAvailable || isSelectedScheduleCurrent ? "disabled" : "primary"}`}
                      disabled={
                        !isSelectedScheduleAvailable ||
                        isSelectedScheduleCurrent
                      }
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 13L9 17L19 7"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                      {isSelectedScheduleCurrent
                        ? "Currently Subscribed"
                        : "Subscribe Now"}
                    </button>

                    {!isSelectedScheduleAvailable && (
                      <div className="notify-section">
                        <button className="notify-button" disabled>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                            <path
                              d="M13.73 21C13.5542 21.3031 13.3018 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </svg>
                          Notify when available
                        </button>
                        <p className="notify-text">
                          This time slot is currently fully booked
                        </p>
                      </div>
                    )}

                    {isSelectedScheduleCurrent && (
                      <div className="current-subscription-info">
                        <p className="info-text">
                          You are currently subscribed to this time slot. To
                          change your subscription, please cancel your current
                          subscription first.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* Empty State */}
            {schedules.length === 0 && (
              <div className="empty-state">
                <div className="empty-icon">
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="#9CA3AF"
                      strokeWidth="2"
                    />
                    <path
                      d="M12 8V12M12 16H12.01"
                      stroke="#9CA3AF"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
                <h3>No schedules available</h3>
                <p>Check back later for new time slots</p>
              </div>
            )}
          </div>
        )}

        {/* Popup Modal */}
        {popup.isOpen && (
          <div className="popup-overlay">
            <div className="popup-content">
              <button className="close-btn" onClick={this.handlePopupClose}>
                ×
              </button>

              <div className="popup-header">
                <h2>
                  {popup.type === "subscribe"
                    ? "Confirm Subscription"
                    : "Cancel Subscription"}
                </h2>
              </div>

              <div className="popup-body">
                {popup.type === "subscribe" ? (
                  <>
                    <p className="confirmation-text">
                      Are you sure you want to subscribe to the schedule at{" "}
                      <strong>
                        {this.formatTime(popup.data.schedule_time)}
                      </strong>
                      ?
                    </p>
                    <p className="info-text">
                      If you want to get schedule in that particular time,
                      please proceed.
                    </p>
                  </>
                ) : (
                  <>
                    <p className="confirmation-text">
                      Are you sure you want to cancel your subscription?
                    </p>
                    <p className="warning-text">
                      This action cannot be undone.
                    </p>
                  </>
                )}
              </div>

              <div className="popup-actions">
                <button
                  className="btn-secondary-popup"
                  onClick={this.handlePopupClose}
                >
                  {popup.type === "subscribe"
                    ? "No, Go Back"
                    : "Keep Subscription"}
                </button>
                <button
                  className={
                    popup.type === "subscribe" ? "btn-primary" : "btn-danger"
                  }
                  onClick={this.handleConfirm}
                >
                  {popup.type === "subscribe" ? "Yes, Proceed" : "Yes, Cancel"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(SchedulePage);
